module.exports = __webpack_public_path__ + "media/images/flags/1x1/syc-d08b55ee44e8a0f298a12dc3e97fd0cc.svg";